module.exports = __webpack_public_path__ + "static/images/3d6f6500.svg";